/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import SearchNotFound from '../../../SearchNotFound';
import userServices from '../../../../commonServices/UserServices';
import services from '../Services';
import Chip from '@material-ui/core/Chip';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import { RotateLeft } from '@material-ui/icons';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme } from '@mui/material/styles'
import xlsx from 'json-as-xlsx';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function OutletListing(props) {
    const screenCode = 'OUTLET';
    let encrypted = "";
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        groupID: "0",
    });
    const [groupList, setGroupList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });
    const GroupSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please select a Group').required('Group Required')
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
        },
        validationSchema: GroupSearchSchema,
        onSubmit: (values) => {
            trackPromise(GetFactoriesByGroupID(values.groupID));
        },
    });

    async function GetFactoriesByGroupID(groupID) {
        var res = await services.GetFactoriesByGroupIDFromOutletScreen(groupID);

        if (res != null) {
            setTableData(res);
        }
    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

   
   useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('Outlet-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            GetFactoriesByGroupID(values.groupID);
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'Outlet-page-search-parameters-id'
        );
    }, []);

    async function getPermissions(IDdata) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'OUTLET');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        const initialValues = IDdata === null;
        if (initialValues) {
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
        }else{
            setValues({
                ...values,
                groupID: IDdata.groupID,
            });
        }
        setIsIDDataForDeduction(IDdata);
    }

    useEffect(() => {
        GetAllGroups();
    }, []);

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForOutletScreen();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function clearAll() {
        setTableData([]);
    }
    async function handleClick(datas) {
        encrypted = await AESEncryptionParam(datas.toString());
        let model = {
            groupID: parseInt(values.groupID),
        }
        sessionStorage.setItem('Outlet-page-search-parameters-id', JSON.stringify(model));
        navigate('/dashboard/viewOutlet/AddEdit/' + encrypted)
    }
    
    async function createDataForExcelTransaction(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Outlet Code': x.factoryCode || '-',
                    'ERIMS Outlet Code': x.erimsOutletCode || '-',
                    'Outlet Name': x.factoryName ||'-',
                    'Grade': x.gradeName ||'-',
                    'Status': x.isActive == 1 ? 'Active' : 'Inactive' || '-',
                }
                res.push(vr);
                });
               res.push({                    
                'Outlet Code': '',                    
                'ERIMS Outlet Code': '',                    
                'Outlet Name': '',  
                'Grade':'',                  
                'Status': '',                                    
                });
                res.push({
                'Outlet Code':"Group : " +  groupList.find(x => x.groupID == values.groupID).groupName || '-',
                'ERIMS Outlet Code':'',
                'Outlet Name':'',
                'Grade':'',                  
                'Status':'',
                });
           
        }
        return res;
    }

    async function createFile() {    
        var file = await createDataForExcelTransaction(tableData);    
        var settings = {        
            sheetName: 'Outlet Details',        
            fileName: 'Outlet Details '+ groupList.find(x => x.groupID == values.groupID).groupName,
            writeOptions: {}    
        };    
    
        let keys = Object.keys(file[0]);    
        let tempcsvHeaders = [];    
    
        keys.map((sitem) => {        
            tempcsvHeaders.push({ label: sitem, value: sitem });    
        });    
    
        let dataA = [        
            {            
                sheet: 'Outlet Details',            
                columns: tempcsvHeaders,            
                content: file        
            }    
        ];    
    
        xlsx(dataA, settings);    
    }
    

    return (
        <>
            <LoadingComponent />
            <Page title="Outlet |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewOutlet/AddEdit/" + AESEncryptionParam("0")}
                        btname="Add"
                        pageName="Outlet"
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Stack width={450}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Stack>
                                    <Grid item md={8} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                color='error'
                                                variant="outlined"
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {tableData.length == 0 ?
                        <SearchNotFound searchQuery="Outlet Factories" />
                        :
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                <TableContainer component={Paper} >
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                            <TableCell align="left" style={{ width: '20%' }}><span style={{ marginLeft: '40px' }}>Outlet Code</span></TableCell>                                            
                                            <TableCell align="left" style={{ width: '20%' }}>Location Code</TableCell>
                                            <TableCell align="left" style={{ width: '20%' }}>Outlet Name</TableCell>
                                            <TableCell align="center" style={{ width: '13%' }}>Grade</TableCell>
                                            <TableCell align="center" style={{ width: '13%' }}>Status</TableCell>
                                            <TableCell align="center" style={{ width: '14%' }}>Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(rowsPerPage > 0
                                                ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                : tableData
                                            ).map((row) => (
                                                <TableRow key={row.factoryID}>
                                                    <TableCell align="left">
                                                        <span  style={{ marginLeft: '40px' }}>{row.factoryCode}</span>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.erimsOutletCode || "-"}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {row.factoryName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {row.gradeName || "-"}
                                                    </TableCell>
                                                    <TableCell align="center">{row.isActive ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />}</TableCell>
                                                    <TableCell align="center">{<IconButton aria-label="delete" onClick={() => handleClick(row.factoryID)}  >
                                                        <EditIcon />
                                                    </IconButton>}</TableCell>
                                                </TableRow>
                                            ))}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                    colSpan={6}
                                                    count={tableData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: {
                                                            'aria-label': 'rows per page',
                                                        },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    ActionsComponent={TablePaginationActions}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                            </Card>
                        </Stack>
                    }
                    {tableData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem',backgroundColor: '#00AB55' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}